import { useContext } from "react";
import { createContext } from "react";

const ClienteContext = createContext({ cliente: null, loading: false, identificador: null });

export const ClienteProvider = ClienteContext.Provider;

export const useCliente = () => {
    return useContext(ClienteContext);
}